import { render, staticRenderFns } from "./RecordTagSelect.vue?vue&type=template&id=081a986f&"
import script from "./RecordTagSelect.vue?vue&type=script&lang=js&"
export * from "./RecordTagSelect.vue?vue&type=script&lang=js&"
import style0 from "./RecordTagSelect.vue?vue&type=style&index=0&id=081a986f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports